// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Logs.css - стили для страницы логов с использованием Ant Design */

.logs-container {
  padding: 16px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.log-item {
  margin-bottom: 8px;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.log-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.log-error {
  border-left: 3px solid #f5222d;
}

.log-warn {
  border-left: 3px solid #faad14;
}

.log-info {
  border-left: 3px solid #1890ff;
}

.log-message {
  max-width: 100%;
  word-break: break-word;
}

.log-details {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

/* Улучшения для Collapse */
.ant-collapse-borderless {
  background-color: transparent;
}

.ant-collapse-borderless > .ant-collapse-item {
  border-bottom: 1px solid #f0f0f0;
}

.ant-list-item:last-child {
  border-bottom: none;
}

/* Улучшенные стили для вкладок */
.ant-tabs-tab:hover {
  color: #1890ff;
}

.ant-tabs-tab-active {
  font-weight: bold;
}

/* Стили для пустого списка */
.ant-empty {
  margin: 32px 0;
}

/* Дополнительные стили для адаптивности */
@media (max-width: 576px) {
  .logs-container {
    padding: 8px;
  }
  
  .ant-card-body {
    padding: 12px;
  }
}

.ant-row.ant-row-center.css-dev-only-do-not-override-240cud {
  display:grid
}`, "",{"version":3,"sources":["webpack://./src/styles/Logs.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;AACF","sourcesContent":["/* Logs.css - стили для страницы логов с использованием Ant Design */\r\n\r\n.logs-container {\r\n  padding: 16px;\r\n}\r\n\r\n.loading-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 300px;\r\n}\r\n\r\n.log-item {\r\n  margin-bottom: 8px;\r\n  transition: all 0.3s ease;\r\n  border-radius: 8px;\r\n}\r\n\r\n.log-item:hover {\r\n  background-color: rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.log-error {\r\n  border-left: 3px solid #f5222d;\r\n}\r\n\r\n.log-warn {\r\n  border-left: 3px solid #faad14;\r\n}\r\n\r\n.log-info {\r\n  border-left: 3px solid #1890ff;\r\n}\r\n\r\n.log-message {\r\n  max-width: 100%;\r\n  word-break: break-word;\r\n}\r\n\r\n.log-details {\r\n  margin-top: 8px;\r\n  color: rgba(0, 0, 0, 0.45);\r\n  font-size: 12px;\r\n}\r\n\r\n/* Улучшения для Collapse */\r\n.ant-collapse-borderless {\r\n  background-color: transparent;\r\n}\r\n\r\n.ant-collapse-borderless > .ant-collapse-item {\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.ant-list-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Улучшенные стили для вкладок */\r\n.ant-tabs-tab:hover {\r\n  color: #1890ff;\r\n}\r\n\r\n.ant-tabs-tab-active {\r\n  font-weight: bold;\r\n}\r\n\r\n/* Стили для пустого списка */\r\n.ant-empty {\r\n  margin: 32px 0;\r\n}\r\n\r\n/* Дополнительные стили для адаптивности */\r\n@media (max-width: 576px) {\r\n  .logs-container {\r\n    padding: 8px;\r\n  }\r\n  \r\n  .ant-card-body {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.ant-row.ant-row-center.css-dev-only-do-not-override-240cud {\r\n  display:grid\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
